















































































































import DeferredAutocomplete from "@/components/misc/DeferredAutocomplete.vue";
import DeferredAutocompleteWrapper from "@/components/misc/DeferredAutocompleteWrapper.vue";
import { Country } from "@/shared/models/country";
import { ListModel } from "@/shared/models/listModel";
import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LatLng } from "./types";
import { DefferedAutocompleteItem } from "../misc/DeferredAutocomplete.vue";
import NumericInput from "@/components/misc/NumericInput.vue";

@Component({
  components: {
    DeferredAutocomplete,
    DeferredAutocompleteWrapper,
    NumericInput,
  },
})
export default class LocationInput extends Vue {
  @Prop() hasCountry?: boolean;
  @Prop() readonly?: boolean;
  @PropSync("marker", { default: { lat: 0, lng: 0 } as LatLng })
  internalMarker?: LatLng;
  @PropSync("countryId") internalCountryId?: number;
  @PropSync("postalId") internalPostalCodeId?: number | null;
  @PropSync("cityId") internalCityId?: number | null;
  @PropSync("streetName") internalStreetName?: string;
  @PropSync("houseNumber") internalHouseNumber?: string;

  required(v: any) {
    return v ? true : this.$t("Validation.Required");
  }
  maxLength(max: number) {
    return (v: string) =>
      v && v.length <= max
        ? true
        : this.$t("Validation.MaxLength", { count: max });
  }

  @Getter("codebooks/countries") countries?: Country[];

  @Ref("mapRef") mapRef?: any;

  center?: LatLng;
  zoom?: number;
  skipMarkerWatch = false;

  get coordinates() {
    return {
      lat: this.internalMarker?.lat ?? undefined,
      lng: this.internalMarker?.lng ?? undefined,
    } as LatLng;
  }

  @Watch("internalMarker", { immediate: true })
  markerChanged(fresh: LatLng | null) {
    if (!this.skipMarkerWatch) {
      this.center = fresh ?? { lat: 20, lng: 0 };
      this.zoom = fresh ? 19 : 1;
      this.mapRef?.$mapPromise.then((map: any) => {
        map.panTo(this.center);
        map.setZoom(this.zoom);
      });
      this.skipMarkerWatch = false;
    }
  }

  markerClicked(evt: any) {
    const c = { lat: evt.latLng.lat(), lng: evt.latLng.lng() } as LatLng;
    this.mapRef?.$mapPromise.then((map: any) => {
      map.panTo(c);
      map.setZoom(19);
    });
  }

  setMarkerToCoordinates(coordinates: LatLng) {
    if (!isNaN(coordinates.lat) && !isNaN(coordinates.lng)) {
      const event = {
        latLng: {
          lat: () => coordinates.lat,
          lng: () => coordinates.lng,
        },
      };

      this.setMarker(event);
      this.mapRef?.$mapPromise.then((map: any) => {
        map.panTo(coordinates);
        map.setZoom(16);
      });
    }
  }

  setMarker(evt: any) {
    if (this.readonly) return;

    const c = { lat: evt.latLng.lat(), lng: evt.latLng.lng() } as LatLng;
    this.skipMarkerWatch = true;
    this.internalMarker = c;
  }

  setPlace(place: any) {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const c = { lat: lat, lng: lng } as LatLng;
    this.mapRef?.$mapPromise.then((map: any) => {
      map.panTo(c);
      map.setZoom(17);
    });

    this.skipMarkerWatch = true;
    this.internalMarker = c;
  }

  get countryItems() {
    return (
      this.countries
        ?.map((x) => ({
          id: x.id,
          text: this.$t(`Country.Official.${x.isoThreeLetterCode}`).toString(),
        }))
        .sort((a, b) => (a.text >= b.text ? 1 : -1)) ?? []
    );
  }

  isById(x: any): x is { id: number } {
    return x && (x as { id: number }).id !== undefined;
  }
  isBySearch(x: any): x is { search: string } {
    return x && !!(x as { search: string }).search;
  }

  @Watch("internalCountryId")
  onCountryChanged(fresh: number, old?: number | null) {
    if (this.readonly) return;
    if (fresh === old || old === null || old === undefined) return;

    this.internalPostalCodeId = null;
    this.internalCityId = null;
  }

  postalFetch(
    val: { id: number } | { search: string }
  ): Promise<DefferedAutocompleteItem[]> {
    if (!this.internalCountryId) return Promise.resolve([]);

    if (this.isById(val)) {
      return this.axios
        .get<any>(`codebooks/postalCodes/${val.id}`)
        .then(({ data }) => [
          {
            id: data.id,
            text: data.code,
          },
        ]);
    } else if (this.isBySearch(val)) {
      return this.axios
        .get<ListModel<any>>("codebooks/postalCodes", {
          params: {
            $orderby: "code",
            countryId: this.internalCountryId,
            code: val.search,
          },
        })
        .then(({ data }) =>
          data.result.map((x) => ({
            id: x.id,
            text: x.code,
          }))
        );
    } else {
      return Promise.resolve([]);
    }
  }
  @Watch("internalPostalCodeId")
  onPostalCodeChanged(fresh: number, old?: number | null) {
    if (this.readonly) return;
    if (fresh === old || old === null || old === undefined) return;

    this.internalCityId = null;
  }

  cityFetch(
    val: { id: number } | { search: string }
  ): Promise<DefferedAutocompleteItem[]> {
    if (!this.internalPostalCodeId) return Promise.resolve([]);

    if (this.isById(val)) {
      return this.axios
        .get<any>(`codebooks/cities/${val.id}`)
        .then(({ data }) => [
          {
            id: data.id,
            text: data.name,
          },
        ]);
    } else if (this.isBySearch(val)) {
      return this.axios
        .get<ListModel<any>>("codebooks/cities", {
          params: {
            $orderby: "name",
            postalCodeId: this.internalPostalCodeId,
            name: val.search,
          },
        })
        .then(({ data }) =>
          data.result.map((x) => ({
            id: x.id,
            text: x.name,
          }))
        );
    } else {
      return Promise.resolve([]);
    }
  }
}
